import { K2Chart } from '../k2/K2Chart';
import { SimpleTable } from '../k2/K2Tables';
import { fmtKc, pctChange } from '../k2/k2utils';
import { dayRows, weekRows } from './analyticsUtils';

const todayIso = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Prague' });

const Pct = ({ v, inverse }) => (v == null ? <span className="text-[#94A3B8]">—</span> : (
  <span className={(inverse ? v > 0 : v < 0) ? 'text-[#DC2626]' : 'text-[#16A34A]'}>{v >= 0 ? '+' : ''}{v.toFixed(1)} %</span>
));

export const TrendView = ({ docs, range, mode, view, amountLabel }) => {
  if (mode === 'compare') {
    const cur = dayRows(docs, range.from, range.to);
    const prev = dayRows(docs, range.prevFrom, range.prevTo);
    const rows = cur.map((d, i) => ({ ...d, label: prev[i] ? `${d.label} / ${prev[i].label.slice(3)}` : d.label, prevAmount: prev[i]?.amount || 0, prevCount: prev[i]?.count || 0 }));
    if (view === 'table') {
      return (
        <SimpleTable testId="an-trend-table" rowKey={(r) => r.key} rows={rows} columns={[
          { key: 'label', label: 'Den (aktuální / předchozí)', className: 'font-medium whitespace-nowrap' },
          { key: 'amount', label: `${amountLabel} – aktuální`, num: true, render: (r) => fmtKc(r.amount), className: 'font-semibold' },
          { key: 'prevAmount', label: 'Předchozí', num: true, render: (r) => fmtKc(r.prevAmount) },
          { key: 'pct', label: 'Změna', num: true, render: (r) => (r.key > todayIso() ? <span className="text-[#94A3B8]">—</span> : <Pct v={pctChange(r.amount, r.prevAmount)} />) },
          { key: 'count', label: 'Dokladů', num: true, render: (r) => `${r.count} / ${r.prevCount}` },
        ]} />
      );
    }
    return <K2Chart testId="an-trend-chart" type={view} data={rows} series={[
      { key: 'amount', name: 'Aktuální období', color: '#16A34A' },
      { key: 'prevAmount', name: 'Předchozí období', color: '#94A3B8', dashed: true },
    ]} />;
  }
  const rows = mode === 'weekly' ? weekRows(docs, range.from, range.to) : dayRows(docs, range.from, range.to);
  if (view === 'table') {
    const cols = [
      { key: 'label', label: mode === 'weekly' ? 'Týden' : 'Datum', className: 'font-medium whitespace-nowrap' },
      { key: 'amount', label: amountLabel, num: true, render: (r) => fmtKc(r.amount), className: 'font-semibold' },
      { key: 'count', label: 'Dokladů', num: true },
    ];
    if (mode === 'weekly') cols.push({ key: 'delta', label: 'Vs. předch. týden', num: true, render: (r) => <Pct v={r.delta} /> });
    return <SimpleTable testId="an-trend-table" columns={cols} rows={rows} rowKey={(r) => r.key} />;
  }
  return <K2Chart testId="an-trend-chart" type={view} data={rows} series={[{ key: 'amount', name: amountLabel, color: '#16A34A' }]} />;
};
